import { render, staticRenderFns } from "./ShopPresetPromotion.vue?vue&type=template&id=29f67d64"
import script from "./ShopPresetPromotion.vue?vue&type=script&lang=js"
export * from "./ShopPresetPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports